import { useTranslation } from "react-i18next";
import { useState } from "react";
import { Grid, GridColumn, GridToolbar } from "@progress/kendo-react-grid";
import { process } from "@progress/kendo-data-query";
import { Window } from "@progress/kendo-react-dialogs";
import { API_GATEWAY, PR_DEP } from "../../../config/globalVariables";
import { Button } from "reactstrap";
import useFetchData from "../../../hooks/useFetchData";
import LoadingPanel from "../../../components/sys-toolbox/LoadingPanel";
import { Checkbox } from "@progress/kendo-react-inputs";
import ParticipantService from "../../../services/srv-participants/ParticipantService";
import MultiSelectFilterCell from "../../../components/GridCell/GridMultiSelectFilterCell";

const initialDataState = {
  sort: [
    {
      field: "aD_SOYAD",
      dir: "asc",
    },
  ],
  filter: null,
};

export const ParticipantDaikinAdd = (props) => {
  const { t } = useTranslation();
  const getPersonelDataUrl = `${API_GATEWAY + PR_DEP}/personel/get-list`;

  const { data: gridData, loading, error } = useFetchData(getPersonelDataUrl);

  const [dataState, setDataState] = useState(initialDataState);
  const [selectedIds, setSelectedIds] = useState(new Set());

  const processedData = process(gridData || [], dataState);

  const [isLoading, setIsLoading] = useState(false);

  const handleCheckboxChange = (dataItem) => {
    setSelectedIds((prevSelectedIds) => {
      const newSelectedIds = new Set(prevSelectedIds);
      if (newSelectedIds.has(dataItem.siciL_NO)) {
        newSelectedIds.delete(dataItem.siciL_NO);
      } else {
        newSelectedIds.add(dataItem.siciL_NO);
      }
      return newSelectedIds;
    });
  };

  const isSelected = (siciL_NO) => selectedIds.has(siciL_NO);

  const handleSelectAll = () => {
    // Filtrelenmiş veriden ID'leri al
    const filteredIds = processedData.data.map((item) => item.siciL_NO);
    setSelectedIds(new Set(filteredIds));
  };

  const handleClearAll = () => {
    setSelectedIds(new Set());
  };

  const onSubmit = () => {
    setIsLoading(true);
    ParticipantService.addEventDaikinParticipant({
      selectedIds: Array.from(selectedIds),
      etkinlikTanimId: props.event.etkinliK_TANIM_ID,
    })
      .then((data) => {
        props.toggleDialog();
        props.setIsAdded(true);
      })
      .catch((error) => {
        console.error("Participant ekleme hatası:", error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleDataStateChange = (e) => {
    console.log("DataState Change Event:", e.dataState);
    console.log("Filters in DataState:", e.dataState.filter?.filters || []);
    setDataState(e.dataState);
  };

  return (
    <>
      <Window
        title={props.title || t("personnel_data")}
        onClose={props.toggleDialog}
        stage={window.innerWidth < 1000 ? "FULLSCREEN" : "DEFAULT"}
        initialHeight={"90vh"}
        initialWidth={"90%"}
        style={{
          left: "50%",
          top: "50%",
          transform: "translate(-50%, -50%)",
          position: "fixed",
          zIndex: 10000,
        }}
      >
        {(loading || isLoading) && <LoadingPanel />}
        {error && (
          <div style={{ textAlign: "center", padding: "20px", color: "red" }}>
            <h4>
              {t("error")}: {error}
            </h4>
          </div>
        )}
        <Grid
          data={processedData}
          {...dataState}
          onDataStateChange={handleDataStateChange}
          sortable={true}
          resizable={true}
          filterable={true}
          pageable={false}
          style={{ height: "800px" }}
        >
          <GridToolbar>
            <Button color="primary" type="button" onClick={handleSelectAll}>
              <i className="fa fa-check-square"></i> {t("select_all")}
            </Button>
            <Button
              color="danger"
              type="button"
              style={{ marginLeft: "10px" }}
              onClick={handleClearAll}
            >
              <i className="fa fa-times-circle"></i> {t("clear_all")}
            </Button>
            <Button
              color="success"
              type="button"
              style={{ marginLeft: "10px" }}
              onClick={onSubmit}
            >
              <i className="fa fa-save"></i> {t("save_selected")}
            </Button>
          </GridToolbar>

          <GridColumn
            width="75px"
            filterable={false}
            cell={(cellProps) => (
              <td>
                <Checkbox
                  checked={isSelected(cellProps.dataItem.siciL_NO)}
                  onChange={() => handleCheckboxChange(cellProps.dataItem)}
                />
              </td>
            )}
          />
          <GridColumn
            field="siciL_NO"
            title={t("registration_number")}
            width="180px"
            filter="text"
          />
          <GridColumn
            field="aD_SOYAD"
            title={t("name") + " " + t("surname")}
            width="270px"
          />
          <GridColumn field="mail" title={t("email")} width="200px" />
          <GridColumn
            field="anA_LOKASYON"
            title={t("location")}
            width="200px"
            filterCell={(cellProps) => (
              <MultiSelectFilterCell
                {...cellProps}
                data={
                  gridData
                    ? Array.from(
                        new Set(
                          gridData
                            .filter((item) => item.anA_LOKASYON)
                            .map((item) => item.anA_LOKASYON)
                        )
                      )
                    : []
                }
              />
            )}
          />
          <GridColumn
            field="yoneticI_AD_SOYAD"
            title={t("manager_1")}
            width="270px"
          />
          <GridColumn field="saP_KODU" title={t("sap_code")} width="120px" />
          <GridColumn
            field={t("TABLO_ALANLARI_CEVIRI.orG_BIRIMI_ADI")}
            title={t("organization_unit")}
            width="250px"
          />
          <GridColumn
            field={t("TABLO_ALANLARI_CEVIRI.unvaN_ADI")}
            title={t("title")}
            width="250px"
          />
          {/* <GridColumn
          field="departmaN_ADI"
          title={t("department")}
          width="250px"
        /> */}
        </Grid>
      </Window>
    </>
  );
};
